import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import ArtesMarcialesPage from './pages/ArtesMarcialesPage';
import HomePage from './pages/HomePage';
import SiteFooter from './components/site/SiteFooter';
import SiteHeader from './components/site/SiteHeader';

const imgBase = '/images/';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const sections = [
    { href: '/#inicio', label: 'Inicio' },
    { href: '/#disciplinas', label: 'Disciplinas' },
    { to: '/artes-marciales', label: 'Bujinkan' },
    { href: '/#richard', label: 'Richard' },
    { href: '/#terapias', label: 'Terapias' },
    { href: '/#horarios', label: 'Horarios' },
    { href: '/#contacto', label: 'Contacto' }
  ];

  return (
    <div className="min-h-screen bg-white text-slate-900 selection:bg-emerald-100 selection:text-emerald-900">
      <SiteHeader
        imgBase={imgBase}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        scrolled={scrolled}
        sections={sections}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/artes-marciales" element={<ArtesMarcialesPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <SiteFooter imgBase={imgBase} />
    </div>
  );
};

export default App;
